import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginWithPhoneNumberPageComponent } from './login-with-phone-number.page';

const routes: Routes = [
  {
    path: '',
    component: LoginWithPhoneNumberPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginWithPhoneNumberPageRoutingModule {}
